// Modules
import { Heading } from '@dasa-health/alma-react'
import styled from 'styled-components'
import breakPoint from 'theme/breakpoints'

export const Aside = styled.aside<{ bgColor?: string }>`
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    padding: 1.5rem 1rem;
    background: #fff;
    flex-direction: column;

    ${breakPoint.desktop} {
        display: flex;
        flex: 2;
        justify-content: center;
        align-items: center;
        padding: 0 1rem;
        background: ${({ bgColor }) => bgColor};
    }
`

export const Box = styled.aside<{ bgColor?: string }>`
    padding: 0;
    background: #fff;

    ${breakPoint.desktop} {
        padding: 2rem;
        flex-direction: column;
        border-radius: 1rem;
        background: #f5f5f5;
        max-width: 22rem;
    }
`

export const Logo = styled.img`
    max-width: fit-content;
    max-height: 1rem;
`

export const Title: typeof Heading = styled(Heading)`
    color: #161616;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 1.5rem */
    margin: 1rem 0;

    ${breakPoint.desktop} {
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 700;
        line-height: 141.5%; /* 1.76875rem */
    }
`

export const Lista = styled.ul`
    display: flex;
    flex-direction: column;
`

export const Item = styled.li`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 0.5rem;
    color: #363636;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */
`

export const Icon = styled.img`
    margin: 0.25rem 0.5rem 0 0;
`
